import { getRandomInt } from '~/bootcamp/Activities/Fractions/Fractions.utils'
import { rangeBetween, shuffle } from '~/utils'

const ACTIVITY_DATA = {
  variables: ['a', 'b', 'x'],
  minNumber: 1,
  maxNumber: 9,
  signs: ['+', '-', '×'],
}
export interface EquationPartsModel {
  integer: number | string
  variable?: string
  sign?: string
}

export enum EquationType {
  Algebraic,
  NonAlgebraic,
}

export interface WhatAlgebraOptionModel {
  equation: string
  type: EquationType
}

/**
 * generates algebraic or non-algebraic equation
 * @param isAlgebraic algebraic or non-algebraic equation
 * @param excludes equations to excludes
 * @returns generated equation
 */
function generateEquation(isAlgebraic: boolean, excludes: string[]): string {
  const totalTerms = Math.random() > 0.5 ? 2 : 3
  const totalNonAlgebraicTerms = !isAlgebraic ? totalTerms : getRandomInt(1, totalTerms - 1)
  const variables = shuffle(ACTIVITY_DATA.variables)
  const signs = shuffle(ACTIVITY_DATA.signs)
  const algebraicNumbers = shuffle(rangeBetween(ACTIVITY_DATA.minNumber, ACTIVITY_DATA.maxNumber))
  const nonAlgebraicNumbers = shuffle(rangeBetween(ACTIVITY_DATA.minNumber, ACTIVITY_DATA.maxNumber))
  const algebraicEquationParts: EquationPartsModel[] = []
  const nonAlgebraicEquationParts: EquationPartsModel[] = []
  // eslint-disable-next-line
  for (let i = 0; i < totalTerms - totalNonAlgebraicTerms; i++) {
    algebraicEquationParts[i] = {
      integer: algebraicNumbers[i] === 1 ? '' : algebraicNumbers[i],
      variable: variables[i],
      sign: signs[0],
    }
  }
  // eslint-disable-next-line
  for (let i = 0; i < totalNonAlgebraicTerms; i++) {
    nonAlgebraicEquationParts[i] = {
      integer: nonAlgebraicNumbers[i],
      sign: signs[0],
    }
  }
  const equationParts = [...algebraicEquationParts, ...nonAlgebraicEquationParts]
  equationParts[0].sign = undefined
  let equation = ''
  equationParts.forEach((item) => {
    equation += `${item.sign ? ` ${item.sign}` : ''} ${item.integer}${item.variable ? `<i>${item.variable}</i>` : ''}`
  })
  if (excludes.includes(equation)) return generateEquation(isAlgebraic, excludes)
  return equation
}

/**
 * generates equations
 * @returns four equations for activity
 */
function generateEquations(): WhatAlgebraOptionModel[] {
  const totalAlgebraic = Math.random() > 0.5 ? 3 : 2
  const options: WhatAlgebraOptionModel[] = []
  const excludes: string[] = []
  // eslint-disable-next-line
  for (let i = 0; i < 4; i++) {
    if (i < totalAlgebraic) {
      options[i] = {
        equation: generateEquation(true, excludes),
        type: EquationType.Algebraic,
      }
    } else {
      options[i] = {
        equation: generateEquation(false, excludes),
        type: EquationType.NonAlgebraic,
      }
    }
    excludes[i] = options[i].equation
  }
  return shuffle(options)
}

/**
 * generates equation for activity
 * @param taskHistory previous equation history
 * @returns new generated equations
 */
export function getWhatAlgebraQuestionData(taskHistory: string[]): WhatAlgebraOptionModel[] {
  const options = generateEquations()
  if (
    taskHistory.includes(`${options[0].equation}-${options[1].equation}-${options[2].equation}-${options[3].equation}`)
  ) {
    return getWhatAlgebraQuestionData(taskHistory)
  }
  return options
}

/**
 * check user answer
 * @param options question options
 * @param answer user answers
 * @returns if the answer is right or wrong
 */
export function checkAnswer(options: WhatAlgebraOptionModel[], answer: boolean[]): boolean {
  let right = true
  options.forEach(({ type }, index) => {
    if (type === EquationType.Algebraic && answer[index] !== true) {
      right = false
    } else if (type === EquationType.NonAlgebraic && answer[index] === true) {
      right = false
    }
  })
  return right
}
